// import Business from '../Sellpoint/Template/index.vue' //BusinessView
// import Settings from '../Settings/index.vue' //SeetingsView
// import Refer from '../Refer/index.vue' //ReferView
// import Help from '../Help/index.vue' //HelpView
//

export default {
    name: 'AccountDashboard',
    //mixins: [Account],
    data () {
        return {
            sps:{},
        }
    },

    components: {
        // 'business-view': Business,
        // 'settings': Settings,
        // 'help-view': Help,
        // 'refer-view': Refer,
    },
     
    methods: {

        back(){
            window.history.back(); 
        },

        setSP(sp){
            this.$store.dispatch('account/userAccountBusiness',sp);
            this.$router.push('/dashboard/business');
        },
      
    },

    created: function(){
        //this.loading = true;
        let self = this;
        //setTimeout(function(){ self.setSP(); }, 1000); //wait for 3sec 
        //setTimeout(function(){ self.setSellpoint(); }, 3000); //wait for 3sec 
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Dashboard/script.js